import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202604",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 9345,
  clicks: 160,
  adsSpendDollars: 585,
  budgetDollars: 600,
  salesDollars: 4875,
  bestEstimateRoas: 8.33,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.97,
  reorderConversions: 17,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
